// Action Types
import AnalyticsTypes from '~/constants/types/AnalyticsTypes';
import IconTypes from '~/constants/types/IconTypes';
import NamesAndNumbersTypes from '~/constants/types/NamesAndNumbersTypes';
import QuoteTypes from '~/constants/types/QuoteTypes';
import TextTypes from '~/constants/types/TextTypes';
// Utils
import {isNames, isNamesOrNumbers} from '~/data/accessors/icon';
import {ID_VIEW_MAP} from '~/constants/ProductConstants';
import {createCanvasRemoveEvents} from './utils';
import {normalizeTagName} from '~/utils/analytics';

const NamesNumbers = {
  start: () => ({
    event: 'lab_namesnumbers_start'
  }),
  add: () => ({
    event: 'lab_namesnumbers_add'
  }),
  editToolsAddNames: () => {
    return {
      event: 'lab_edit_tools',
      tool_icon_type: 'namesandnumbers',
      tool_name: 'names_enabled',
      tool_value: 'on',
      tool_source: 'panel'
    };
  },
  editToolsAddNumbers: () => {
    return {
      event: 'lab_edit_tools',
      tool_icon_type: 'namesandnumbers',
      tool_name: 'numbers_enabled',
      tool_value: 'on',
      tool_source: 'panel'
    };
  },
  editToolsPosition: (_, {payload}) => {
    const {type, viewId} = payload;
    if (!isNamesOrNumbers(type)) return null;
    return {
      event: 'lab_edit_tools',
      tool_icon_type: 'namesandnumbers',
      tool_name: isNames(type) ? 'name_position' : 'number_position',
      tool_value: ID_VIEW_MAP[viewId],
      tool_source: 'panel'
    };
  },
  editToolsFontHeight: (_, {payload}) => {
    const {fontHeight, iconType} = payload;
    if (!isNamesOrNumbers(iconType)) return null;
    return {
      event: 'lab_edit_tools',
      tool_icon_type: 'namesandnumbers',
      tool_name: isNames(iconType) ? 'name_height' : 'number_height',
      tool_value: fontHeight,
      tool_source: 'panel'
    };
  },
  editToolsColor: (_, {payload}) => {
    const {color, type} = payload;
    if (!isNamesOrNumbers(type) || !color?.name) return null;
    return {
      event: 'lab_edit_tools',
      tool_icon_type: 'namesandnumbers',
      tool_name: isNames(type) ? 'name_color' : 'number_color',
      tool_value: normalizeTagName(color.name),
      tool_source: 'panel'
    };
  },
  list: () => ({
    event: 'lab_namesnumbers_names_list'
  }),
  complete: (_, {meta}) => {
    if (meta?.source !== 'NAMES_NUMBERS') return null;
    return {
      event: 'lab_namesnumbers_names_complete'
    };
  },
  remove: (_, {payload}) => {
    return createCanvasRemoveEvents(payload, {
      targetIconType: 'NAMES_NUMBERS'
    });
  }
};

const NamesNumbersEvents = {
  [AnalyticsTypes.NAMES_AND_NUMBERS]: NamesNumbers.start,
  [AnalyticsTypes.NAMES_AND_NUMBERS_GET_STARTED]: NamesNumbers.add,
  [NamesAndNumbersTypes.ADD_NAMES]: NamesNumbers.editToolsAddNames,
  [NamesAndNumbersTypes.ADD_NUMBERS]: NamesNumbers.editToolsAddNumbers,
  [AnalyticsTypes.NAMES_AND_NUMBERS_POSITION]: NamesNumbers.editToolsPosition,
  [TextTypes.UPDATE_FONT_HEIGHT]: NamesNumbers.editToolsFontHeight,
  [AnalyticsTypes.NAMES_AND_NUMBERS_COLORS]: NamesNumbers.editToolsColor,
  [AnalyticsTypes.NAMES_AND_NUMBERS_COMPLETE]: NamesNumbers.list,
  [QuoteTypes.UPDATE_PRODUCT_QUANTITIES]: NamesNumbers.complete,
  [IconTypes.REMOVE]: NamesNumbers.remove
};

export default NamesNumbersEvents;
